import CmsComponentGlyph from "@/helpers/editor/components/CmsComponentGlyph.js";
import CmsBlock from "@/helpers/editor/blocks/CmsBlock.js";

export default class CmsBlockGlyph extends CmsBlock {
    static typeDef = {
        name: `Glyph|Icône`,
        type: `glyph`,
        category: `base`,
        glyph: `fa-icons`,
        isParent: false
    }

    constructor(data, page) {
        super(data, page);

        this.glyph = new CmsComponentGlyph(this.glyph);
        this.glyph.required = true;
        this.glyph.standalone = true;

        if (!data) {
            this.glyph.glyph = `fa-icons`;
        }
    }
}
